import type { SVGProps } from 'react';

const SvgSlackLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_20_20111)">
      <path
        d="M3.42657 10.0785C3.42657 10.9982 2.68326 11.7415 1.76358 11.7415C0.843893 11.7415 0.100586 10.9982 0.100586 10.0785C0.100586 9.15883 0.843893 8.41553 1.76358 8.41553H3.42657V10.0785ZM4.25807 10.0785C4.25807 9.15883 5.00137 8.41553 5.92106 8.41553C6.84074 8.41553 7.58405 9.15883 7.58405 10.0785V14.236C7.58405 15.1557 6.84074 15.899 5.92106 15.899C5.00137 15.899 4.25807 15.1557 4.25807 14.236V10.0785Z"
        fill="#E01E5A"
      />
      <path
        d="M5.92096 3.40167C5.00128 3.40167 4.25797 2.65836 4.25797 1.73868C4.25797 0.818991 5.00128 0.0756836 5.92096 0.0756836C6.84065 0.0756836 7.58395 0.818991 7.58395 1.73868V3.40167H5.92096ZM5.92096 4.24576C6.84065 4.24576 7.58395 4.98907 7.58395 5.90875C7.58395 6.82844 6.84065 7.57175 5.92096 7.57175H1.75088C0.831198 7.57175 0.0878906 6.82844 0.0878906 5.90875C0.0878906 4.98907 0.831198 4.24576 1.75088 4.24576H5.92096Z"
        fill="#36C5F0"
      />
      <path
        d="M12.5862 5.90875C12.5862 4.98907 13.3295 4.24576 14.2492 4.24576C15.1689 4.24576 15.9122 4.98907 15.9122 5.90875C15.9122 6.82844 15.1689 7.57175 14.2492 7.57175H12.5862V5.90875ZM11.7547 5.90875C11.7547 6.82844 11.0114 7.57175 10.0917 7.57175C9.17202 7.57175 8.42871 6.82844 8.42871 5.90875V1.73868C8.42871 0.818991 9.17202 0.0756836 10.0917 0.0756836C11.0114 0.0756836 11.7547 0.818991 11.7547 1.73868V5.90875Z"
        fill="#2EB67D"
      />
      <path
        d="M10.0917 12.573C11.0114 12.573 11.7547 13.3163 11.7547 14.236C11.7547 15.1557 11.0114 15.899 10.0917 15.899C9.17202 15.899 8.42871 15.1557 8.42871 14.236V12.573H10.0917ZM10.0917 11.7415C9.17202 11.7415 8.42871 10.9982 8.42871 10.0785C8.42871 9.15883 9.17202 8.41553 10.0917 8.41553H14.2618C15.1815 8.41553 15.9248 9.15883 15.9248 10.0785C15.9248 10.9982 15.1815 11.7415 14.2618 11.7415H10.0917Z"
        fill="#ECB22E"
      />
    </g>
    <defs>
      <clipPath id="clip0_20_20111">
        <rect fill="white" height={16} width={16} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSlackLogo;
